import axios from "axios";
import { IP } from "./config";

// 查询会员用户
export async function selectUservip({
  type = "",
  vip_number = "",
  user_name = "",
  user_phone = "",
  create_time = "",
  storeId = "",
}) {
  var resp = await axios.post(`${IP}/uservip/selectByStore`, {
    type,
    vip_number,
    user_name,
    user_phone,
    create_time,
    storeId,
  });
  return resp;
}

// 新增
export async function addUservip(data) {
  var resp = await axios.post(`${IP}/uservip/add`, data);
  return resp.data;
}

// 修改
export async function updateUservip(data) {
  var resp = await axios.post(`${IP}/uservip/updata`, data);
  return resp.data;
}

// 删除
export async function deleteUservip(data) {
  var resp = await axios.post(`${IP}/uservip/delete`,data);
  return resp;
}


/* 会员卡记录 */
export async function selectVipcardrecode({
  message = "",
  user_phone = "",
  create_time = "",
  storeId,
}) {
  var resp = await axios.post(`${IP}/vipcardrecode/selectByStoreId`, {
    user_phone,
    message,
    create_time,
    storeId,
  });
  return resp;
}
